import React, { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { featureFlagClient } from '@trello/feature-flag-client';
import { isBoardPath } from 'app/gamma/src/util/url';

export const BloombergAuthBannerWrapper: React.FC = () => {
  const BloombergAuthBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "bloomberg-auth-banner" */ 'app/src/components/Butler/BloombergAuthBanner'
      ),
    {
      preload: false,
      namedImport: 'BloombergAuthBanner',
    },
  );
  const canShowBLPBanner = featureFlagClient.get(
    'workflowers.show-blp-banner',
    false,
  );

  // Only show the Banner in board views
  const isBoardView = isBoardPath(new URL(window.location.href).pathname);
  if (!canShowBLPBanner || !isBoardView) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <BloombergAuthBanner />
    </Suspense>
  );
};
